<template>
  <gj-popover lazy placement="bottom" width="300" v-model="visible"  popper-class="list-edit-good-title">
    <el-form :model="form" ref="form" class="gj-form">
      <el-form-item label=" " prop="title" :rules="[{ validator: validate, trigger: 'blur' }]">
        <gj-textarea
          v-model="form.title"
          maxlength="500"
          show-word-limit
          :autosize="{ minRows: 4, maxRows: 8 }"
          :styles="{ width: '300px' }"
          placeholder="请输入"
        ></gj-textarea>
      </el-form-item>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="visible = false" style="border: 1px solid #1F6EEF;height:26px">取消</el-button>
        <gj-button type="primary" size="mini" @click="confirm" v-loading="loading" style="height:26px">确定</gj-button>
      </div>
    </el-form>
    <i class="el-icon-edit" slot="reference"></i>
  </gj-popover>
</template>

<script>
import { editGoodTitle } from '@/api/sale';
export default {
  name: 'edit-good-title',
  props: {
    row: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  data() {
    return {
      validate: (rule, value, callback) => {
        if (value) {
          callback();
        } else {
          callback(new Error('请输入标题'));
        }
      },
      visible: false,
      loading: false,
      form: {
        title: this.row.title,
      },
    };
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            listingId: this.row.id,
            title: this.form.title,
          };
          editGoodTitle(params)
            .then(() => {
              this.visible = false;
            })
            .complete(() => (this.loading = false));
        }
      });
    },
  },
};
</script>
<style lang="scss">
.list-edit-good-title{
  padding-bottom: 12px !important;
   .el-form-item{
    margin-bottom: 12px !important;
  }
}

</style>
